import React from 'react';
import { extractCategoryKey, useCategories } from 'components/hooks/services/useCategories';
import { useLoggerTracking } from 'components/hooks/logger/useLoggerTracking';
import { useApplicationContext } from 'components/hooks/UseApplicationContext';
import { TrackedFeature, TrackedPage, TRACKING_PARAM_KEYS } from 'services/Logger';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { RoutePaths } from 'routes/RoutePaths';

interface QuicksearchStartTypingProps {
    onCategoryClick: () => void;
}

export const QuicksearchStartTyping: FC<QuicksearchStartTypingProps> = ({ onCategoryClick }) => {
    const categories = useCategories();
    const { canSearchPersonsAndCompanies } = useApplicationContext();
    const { t: translate } = useTranslation('service-list');
    const track = useLoggerTracking();

    return <div
        className="position-absolute overflow-auto w-100 p-3 bg-lvl1 border shadow-max z-2"
        style={{ maxHeight: '81vh' }}
    >
        {categories.length > 0 && <h4 className="quicksearch-title text-secondary">
            {translate('suggestedCategories')}
        </h4>
        }
        {categories.map((x) => (
            <Link
                key={x.key}
                to={RoutePaths.Catalog.Browse.url(extractCategoryKey(x.key))}
                className="badge badge-default badge-lg badge-prepend-square me-1 mb-2 py-2"
                onClick={() => {
                    track(TrackedPage.QuickSearch, TrackedFeature.QuickSearch, { [TRACKING_PARAM_KEYS.searchedTerm]: x.key });
                    onCategoryClick();
                }}
            >
                {x.label}
            </Link>
        ))}
        <div className="flex my-4 text-secondary">
            <div className="text-center">
                <i className="icon icon-xl">search</i>
            </div>
            <div className="text-center">
                {canSearchPersonsAndCompanies
                    ? <>
                        <p className="h4">{translate('searchAnything')}</p>
                        <p>{translate('searchAnythingSubtitle')}</p>
                    </>
                    : <>
                        <p className="h4">
                            {translate('searchServicesPlaceHolder')}
                        </p>
                    </>
                }
            </div>
        </div>
    </div>;
};
